import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ChangeOrderModel } from 'src/app/models/api/change-order.model';
import { Observable } from 'rxjs';
import { BuilderValidationSummaryModel } from 'src/app/models/builder/builder-validation-summary.model';
import { BuilderRequestModel } from 'src/app/models/builder/builder-request.model';
import { BuilderRequestAutoExportSettingsModel } from 'src/app/models/builder/builder-request-auto-export-settings.model';

/**
 * API client for the Builder-Request API
 */
@Injectable({
    providedIn: 'root'
})
export class BuilderRequestApiClient {

    private ControllerEndpoint: string = environment.apiUrl + "/fe-api/builder-request/";


    constructor(private httpClient: HttpClient) { }

    /**
     * Get the Request for builder (if allowed)
     * @param requestGuid 
     */
    async Get(requestGuid: string): Promise<Observable<BuilderRequestModel>> {
        // let request: Observable<BuilderRequestModel> = this.httpClient.get<BuilderRequestModel>(environment.apiUrl + "/requests/" + dossierId + "/DashboardItem").pipe(
        //   map((req: BuilderRequestModel) => {
        //     let documents = req.documentInfo.filter(doc => !doc.documentType.toLocaleLowerCase().endsWith("html"));
        //     req.documentInfo = documents;
        //     return req;
        //   })
        // );
        return await this.httpClient.get<BuilderRequestModel>(this.ControllerEndpoint + requestGuid);
    }
    
    
    GetSources(): Observable<string[]> {
        return this.httpClient.get<string[]>(this.ControllerEndpoint + "sources");
    }
    /**
     *  Update the auto export data for the request.
     *  -HANDLES THE SUBSCRIBE
     */
    SetAutoExport(model: BuilderRequestAutoExportSettingsModel): void {
        this.httpClient.post<BuilderValidationSummaryModel>(this.ControllerEndpoint + "auto-export", model).subscribe();
    }
    /**
     * 'Sends' the Request (if allowed)
     * @param requestGuid 
     * @returns ValidationResult: Ok = Send, BadRequest = FAILED
     */
    Send(requestGuid: string): Observable<BuilderValidationSummaryModel> {
        return this.httpClient.post<BuilderValidationSummaryModel>(this.ControllerEndpoint + requestGuid + "/send", {});
    }
    /**
     * 'Sends' the Request (if allowed)
     * @param requestGuid 
     * @returns ValidationResult: Ok = Send, BadRequest = FAILED
     */
    Validate(requestGuid: string): Observable<BuilderValidationSummaryModel> {
        return this.httpClient.get<BuilderValidationSummaryModel>(this.ControllerEndpoint + requestGuid + "/validate");
    }
    /**
     * Changes the document order to the Newly given order
     * @param requestGuid 
     * @param indexedDocuments 
     * @returns 
     */
    changeDocumentOrder(requestGuid: string, indexedDocuments: ChangeOrderModel[]) {
        return this.httpClient.post(this.ControllerEndpoint + requestGuid + "/ChangeDocumentOrder", indexedDocuments);
    }

}
